import React from "react";

import { useTranslation } from "react-i18next";

import Button, { Color } from "../../../../Form/Button";
import { DefaultTooltip } from "../../../Tooltip";
import useStyles from "../../styles";
import { UploadCSVFileHandles } from "../UploadCSVCartons";

interface Props {
  show: boolean;
  allCartonsAlreadyReceived?: boolean;
  loading?: boolean;

  uploadCSVReceiveRef: React.RefObject<UploadCSVFileHandles>;
}

const UploadCSVReceiveButton = (props: Props) => {
  const { show, loading, allCartonsAlreadyReceived, uploadCSVReceiveRef } = props;

  const classes = useStyles();
  const { t: translate } = useTranslation();

  const onClick = () => uploadCSVReceiveRef.current?.open();

  if (!show) return null;

  return (
    <DefaultTooltip
      title={
        allCartonsAlreadyReceived ? translate("allCartonsHaveAlreadyBeenMarkedAsReceived") : ""
      }
    >
      <div>
        <Button
          variant="outlined"
          loading={loading}
          customColor={Color.SECONDARY_OUTLINED}
          onClick={onClick}
          disabled={allCartonsAlreadyReceived}
        >
          <span className={classes.buttonText}>{translate("receiveUsingCSV")}</span>
        </Button>
      </div>
    </DefaultTooltip>
  );
};

export default UploadCSVReceiveButton;
